import {
  type FlowGenerateFileBlockConfig,
  FlowGenerateFileBlockConfigSchema,
  FlowGenerateFileMode,
} from 'flow-schema';

import { GenerateFileBlockFormFields } from './FormFields.tsx';
import { GenerateFileBlockDocumentation } from './documentation';
import { type BlockConfigProps } from '../../types';

type GenerateFileBlockConfig = FlowGenerateFileBlockConfig;

export const GenerateFileConfig: BlockConfigProps<GenerateFileBlockConfig> = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'generateFile',
  defaultConfig: {
    mode: FlowGenerateFileMode.Markdown,
    markdown: '',
  },
  configFields: {
    schema: FlowGenerateFileBlockConfigSchema,
    FormFields: GenerateFileBlockFormFields,
  },
  documentationMarkdown: GenerateFileBlockDocumentation,
};
